

export default {
    name: "listitem_download",
    props: {
        content: Object
    }
}

